import React__default from 'react';
import styled from 'styled-components';
import ChevronDownIcon from '../components/ChevronDownIcon.js';
import { FieldSize } from '../constants.js';
import { withTheming, getFocusStyles, IconSize, InlineChildren, InlineChildrenAlignment, InlineChildrenJustification, InlineChildrenSize, Text, TextColor, TextStyle, TextOverflow, IconColor } from '@doordash/design-language';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CaretDirection;

(function (CaretDirection) {
  CaretDirection["Up"] = "DIRECTION/UP";
  CaretDirection["Down"] = "DIRECTION/DOWN";
})(CaretDirection || (CaretDirection = {}));

var CountryCodeHelperControl = function CountryCodeHelperControl(_ref) {
  var accessibilityAttributes = _ref.accessibilityAttributes,
      isExpanded = _ref.isExpanded,
      hasError = _ref.hasError,
      clickHandler = _ref.clickHandler,
      sizeString = _ref.sizeString,
      controlText = _ref.controlText;
  return /*#__PURE__*/React__default.createElement(ControlContainer, _extends({}, accessibilityAttributes, {
    isExpanded: isExpanded,
    hasError: hasError,
    onClick: clickHandler,
    size: sizeString
  }), /*#__PURE__*/React__default.createElement(InlineChildren, {
    alignItems: InlineChildrenAlignment.Center,
    justifyContent: InlineChildrenJustification.SpaceBetween,
    size: InlineChildrenSize.XxxSmall
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: TextColor.CurrentColor,
    styles: TextStyle["Field".concat(sizeString, "Input")],
    overflow: TextOverflow.Truncate
  }, controlText), /*#__PURE__*/React__default.createElement(RotatingControlIcon, {
    direction: isExpanded ? CaretDirection.Up : CaretDirection.Down
  }, /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    color: IconColor.CurrentColor
  }))));
};

var ControlContainer = withTheming(styled.button.attrs(function () {
  return {
    type: 'button'
  };
}).withConfig({
  displayName: "CountryCodeHelperControl__ControlContainer",
  componentId: "sc-bs3yt8-0"
})(["height:", "px;padding:", ";color:", ";border-radius:", ";border:none;box-shadow:", ";background-color:", ";white-space:nowrap;max-width:100%;&:focus-within{background-color:", ";color:", ";", ";}", ""], function (_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;
  return theme.Size["Field".concat(size)];
}, function (_ref3) {
  var size = _ref3.size;
  return "0px ".concat(FieldSize[size], "px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.Colors.FieldsForegroundInactive;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.BorderRadius.FieldsInputDefault, "px 0px 0px ").concat(theme.BorderRadius.FieldsInputDefault, "px");
}, function (_ref6) {
  var theme = _ref6.theme;
  return "inset 0 0 0 ".concat(theme.BorderWidth.FieldsDefault, "px ").concat(theme.Colors.FieldsBorderInactive);
}, function (_ref7) {
  var isExpanded = _ref7.isExpanded,
      theme = _ref7.theme;
  return isExpanded ? theme.Colors.FieldsBackgroundActive : theme.Colors.FieldsBackgroundInactive;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.Colors.FieldsBackgroundActive;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.Colors.FieldsForegroundActive;
}, function (_ref10) {
  var theme = _ref10.theme;
  return getFocusStyles({
    theme: theme,
    focusColor: theme.Colors.FieldsBorderActive,
    shouldUseFocusRing: false,
    shouldBeInset: true,
    focusWidth: theme.BorderWidth.FieldsFocus
  });
}, function (props) {
  return props.hasError && "\n      background-color: ".concat(props.theme.Colors.FieldsBackgroundError, ";\n      color: ").concat(props.theme.Colors.FieldsForegroundError, ";\n      box-shadow: inset 0 0 0 ").concat(props.theme.BorderWidth.FieldsError, "px\n        ").concat(props.theme.Colors.FieldsBorderError, ";\n    ");
}));
var RotatingControlIcon = styled.div.withConfig({
  displayName: "CountryCodeHelperControl__RotatingControlIcon",
  componentId: "sc-bs3yt8-1"
})(["height:", "px;width:", "px;transform:rotate(", ");transition:transform 0.2s ease-out;"], IconSize.Medium, IconSize.Medium, function (props) {
  return props.direction === CaretDirection.Up ? '180deg' : '0deg';
});

export { CountryCodeHelperControl as default };
